import AppliedChips from "./AppliedChips";
export default AppliedChips;
